import { addToCart } from './Utils';
import { gaDesignerSubstep,gaDesignerStepComplete,gaEmptyPositionPopup, gaAddToCart} from "./googleAnalytics";

export const nextStep = (
	selectedTemplate,
	selectedStage,
	setSnackBar,
	profileGuid,
	setSelectedStage,
	setShowModal,
	designGuid,
	orderItemID,
	productId,
	setLoading,
	stoleMeta,
	currentStep,
	substemNameBranding,
	setsubstemNameZone,
	brandingTab,
	setinfoDesignModalShow
) => {
	let nextZone = '';
	const showHideInfoDesignModal = (event) => {
		setinfoDesignModalShow(true);
		setTimeout(function() {setinfoDesignModalShow(false);},7000);
		};
	switch (selectedStage) {
		case 'stole-design':
			gaDesignerStepComplete(
				currentStep,
				selectedStage,
				selectedTemplate,				
			  );
			setSelectedStage('school-branding');	
			break;
		case 'school-branding':
		    showHideInfoDesignModal();
			nextZone = getNextZone(selectedTemplate, selectedStage);
			setSelectedStage('your-stole-' + nextZone?.zoneCode);
			gaDesignerSubstep(
				currentStep,
				selectedStage,
				setSelectedStage,
				selectedTemplate,
				substemNameBranding,
				brandingTab
			  );
			  gaDesignerStepComplete(
				currentStep,
				selectedStage,
				selectedTemplate				
			  );
			break;
		case 'review-order':
			gaAddToCart(selectedTemplate)
			var checkboxChecked=document.querySelector('#customCheck1').checked;
			var toolTipContent=document.querySelector('.review-pointer-tooltip');
			checkboxChecked?
		    addToCart(
			selectedTemplate,
			setSnackBar,
			profileGuid,
			designGuid,
			orderItemID,
			productId,
			selectedStage,
			setLoading,
			stoleMeta
		):toolTipContent.style.display="block";
			break;			
		default:
			if (selectedStage.indexOf('your-stole') !== -1) {
				checkZoneStatus(
					selectedTemplate,
					selectedStage,
					setSelectedStage,
					setShowModal,
					setsubstemNameZone
				);
			 setsubstemNameZone === "text"
         ? (brandingTab = 0)
         : setsubstemNameZone === "schoolAsset"
         ? (brandingTab = 1)
         : (brandingTab = 2);
			}
			break;
	}
};

export const goBack = (selectedTemplate, selectedStage, setSelectedStage, setBrandingTab, brandingTab) => {
	let prev = '';
	let prevZone = '';
	switch (selectedStage) {
		case 'school-branding':
			if (brandingTab === 0) {
				prev = 'stole-design';
			} else {
				setBrandingTab(brandingTab-1);
			}
			break;
		case 'review-order':
			prevZone = getPrevZone(selectedTemplate, selectedStage);
			prev = 'your-stole-' + prevZone.zoneCode;
			break;
		default:
			prevZone = getPrevZone(selectedTemplate, selectedStage);
			if (prevZone === 'school-branding') {
				prev = prevZone;
				setBrandingTab(3)
			}
			else {
				prev = 'your-stole-' + prevZone.zoneCode;
			}
			break;
	}
	prev && setSelectedStage(prev);
};

export const getNextZone = (selectedTemplate, selectedStage) => {
	let nextZone = {};
	let zones = selectedTemplate && selectedTemplate.zones;
	zones = (zones && zones.sort((a, b) => a.zoneSort - b.zoneSort)) || [];
	if (selectedStage === 'school-branding') {
		nextZone = zones[0];
	}
	if (selectedStage.indexOf('your-stole') !== -1) {
		let presentZoneCode = selectedStage.slice(11);
		let presentZoneIndex = zones.findIndex(
			(zone) => zone.zoneCode === presentZoneCode
		);
		presentZoneIndex = presentZoneIndex === -1 ? 0 : presentZoneIndex;
		if (presentZoneIndex === zones.length - 1) {
			nextZone = 'review-order';
		} else {
			nextZone = zones[presentZoneIndex + 1];
		}
	}
	return nextZone;
};

export const getPrevZone = (selectedTemplate, selectedStage) => {
	let prevZone = {};
	let zones = selectedTemplate && selectedTemplate.zones;
	zones = (zones && zones.sort((a, b) => a.zoneSort - b.zoneSort)) || [];
	if (selectedStage === 'review-order') {
		prevZone = zones[zones.length - 1];
	}
	if (selectedStage.indexOf('your-stole') !== -1) {
		let presentZoneCode = selectedStage.slice(11);
		let presentZoneIndex = presentZoneCode ? zones.findIndex(
			(zone) => zone.zoneCode === presentZoneCode
		) : 0;
		if (presentZoneIndex === 0) {
			prevZone = 'school-branding';
		} else {
			prevZone = zones[presentZoneIndex - 1];
		}
	}
	return prevZone;
};

export const getZoneDetails = (selectedTemplate, selectedStage) => {
	let zones = selectedTemplate && selectedTemplate.zones;
	zones = (zones && zones.sort((a, b) => a.zoneSort - b.zoneSort)) || [];
	let presentZoneCode = selectedStage.slice(11);
	let zoneDetails = zones.find((zone) => zone.zoneCode === presentZoneCode);
	return zoneDetails || zones[0];
};

export const getDetails = (
	stoleMeta,
	selectedStage,
	selectedTemplate,
	setSelectedZone,
	setCurrentStep,
	setButtonText,
	setHeaderText,
	visited,
	setVisited
) => {
	let constants = stoleMeta && stoleMeta.configContainer;
	let reviewContainer = stoleMeta && stoleMeta.reviewContainer;
	let footer =
		stoleMeta && stoleMeta.configContainer && stoleMeta.configContainer.footer;
	let nextZone;
	switch (selectedStage) {
		case 'stole-design':
			setCurrentStep(0);
			setButtonText(footer && footer.brandingBtn);
			setHeaderText(constants && constants.variantSelectTitle);
			setVisited([...visited,1]);
			break;
		case 'school-branding':
			setCurrentStep(1);
			setButtonText(footer && footer.stoleBtn);
			setHeaderText(constants && constants.brandingTitle);
			setVisited([...visited,2]);
			break;
		case 'review-order':
			setCurrentStep(3);
			setHeaderText(reviewContainer && reviewContainer.title);
			setButtonText('Add to cart');
			setVisited([...visited,4]);
			gaDesignerStepComplete(
				2,
				selectedStage,
				selectedTemplate				
			  );
			break;
		default:
			if (selectedStage.indexOf('your-stole') !== -1) {
				let zoneDetails = getZoneDetails(selectedTemplate, selectedStage);
				setSelectedZone(zoneDetails);
				setCurrentStep(2);
				setVisited([...visited,3]);
				nextZone = getNextZone(selectedTemplate, selectedStage);
				if (nextZone === 'review-order') {
					setButtonText('Review order');
				} else {
					setButtonText(nextZone.zoneName);
				}
				setHeaderText(
					constants &&
						constants.zoneTitle.replace('<<zoneName>>', zoneDetails.zoneName)
				);
			}
			break;
	}
};
export const stoleImages = [
	{
		id: 'standard',
		title: 'STANDARD',
	},
	{
		id: 'enhanced',
		title: 'ENHANCED',
	},
	{
		id: 'deluxe',
		title: 'DELUXE',
	},
	{
		id: 'premium',
		title: 'PREMIUM',
	},
];

export const checkZoneStatus = (
	selectedTemplate,
	selectedStage,
	setSelectedStage,
	setShowModal,
	setsubstemNameZone,
	brandingTab
) => {
	let currentZone = getZoneDetails(selectedTemplate, selectedStage);
	let isempty = false;
	if (Object.keys(currentZone.data).length) {
		let data = currentZone.data;
		if (data.decorType === 'graphic') {
			if (data.assetId || data.assetName || data.groupCode) {
				isempty = false;
			} else {
				isempty = true;
			}
		} else {
			data.textLines && data.textLines.length
				? (isempty = data.textLines.every( e  => !e))
				: (isempty = true);
		}
	} else {
		isempty = true;
	}
	setsubstemNameZone === "text"
	? (brandingTab = 0)
	: setsubstemNameZone === "schoolAsset"
	? (brandingTab = 1)
	: (brandingTab = 2);
	let EmptyZoneModalcurrentStep=2;
	let presentZoneStage = selectedStage.slice(11).replace("-"," ").toUpperCase();
	if (!isempty) {
		let nextZone = getNextZone(selectedTemplate, selectedStage);
		if (nextZone === 'review-order') { 
			setSelectedStage(nextZone);
		}
		else {
			setSelectedStage('your-stole-' + nextZone?.zoneCode);
		}
		gaDesignerSubstep(
			EmptyZoneModalcurrentStep,
			selectedStage,
			setSelectedStage,
			selectedTemplate,
			presentZoneStage,
			currentZone.zoneSort-1
			);

	} else {
		setShowModal(true);
		gaEmptyPositionPopup(
			EmptyZoneModalcurrentStep+1,
	        selectedStage,
			selectedTemplate,
			presentZoneStage,
			currentZone.zoneSort-1
			);
	}
};

export const selectZoneNavigation = (e,brandingTab) => {
	const topvalue=80;
	const el = document.querySelector('#mobile-designbody');
	if (e === 'your-stole-upper-right' || e === 'your-stole-upper-left' || (e === 'school-branding' && brandingTab === 3)) {
		el.scrollTop = topvalue;
	} else if (
		e === 'your-stole-middle-left' ||
		e === 'your-stole-middle-right'
	) {
		el.scrollTop = topvalue+120;
	} else if (
		e === 'your-stole-lower-left' ||
		e === 'your-stole-lower-right'
	) {
		el.scrollTop = topvalue+200;
	} else if (e === 'your-stole-tip-left' || e === 'your-stole-tip-right') {
		el.scrollTop = topvalue+280;
	}
	
};